import { render, staticRenderFns } from "./SpotsIcon.vue?vue&type=template&id=86e84180"
import script from "./SpotsIcon.vue?vue&type=script&lang=js"
export * from "./SpotsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports